import React from 'react';

import { DEFAULT_ACCORDION_GAP, DEFAULT_ACCORDION_THEME } from './constants';
import type { AccordionGap, AccordionTheme } from './types';

interface AccordionWrapperProps {
  data?: { styles?: { theme?: AccordionTheme; gap?: AccordionGap } };
}

/**
 * Envolve view/edit do accordion expondo as classes modificadoras de cor e
 * espaçamento. O `_accordion.scss` define os tokens `--acc-*` por classe
 * (`--dark-blue`, `--gap-md`, ...), por isso emitimos classes — não `data-*`.
 *
 * A cor sai do Theme picker nativo e fica em `data.styles.theme`; o
 * espaçamento, em `data.styles.gap` (ver `config/blocks/enhancers/accordion.ts`).
 */
export const withAccordionColor = (Wrapped: React.ComponentType<any>) => {
  const Wrapper = (props: AccordionWrapperProps) => {
    const theme = props.data?.styles?.theme || DEFAULT_ACCORDION_THEME;
    const gap = props.data?.styles?.gap || DEFAULT_ACCORDION_GAP;
    return (
      <div
        className={`mpf-accordion-color mpf-accordion-color--${theme} mpf-accordion-color--gap-${gap}`}
      >
        <Wrapped {...props} />
      </div>
    );
  };

  Wrapper.displayName = `withAccordionColor(${
    Wrapped?.displayName || Wrapped?.name || 'Accordion'
  })`;

  return Wrapper;
};

export default withAccordionColor;
